declare let gon: any

/*
  This is a staging recaptcha key.
  If you are going to use Send to phone component in an environment that does not support gon,
  you should implement your own mechanism of stage-based captcha keys
*/
let recaptchaSiteKey = '6Lf5_HIUAAAAAFRr2FRYEtZNMKZmJb5XJRb63X_f'

if ('gon' in window) {
  recaptchaSiteKey = gon.recaptchaSiteKey
}

export const RECAPTCHA_SITE_KEY = recaptchaSiteKey
